import { useApolloClient } from '@apollo/client'
import update from 'immutability-helper'

import { MUTATION_DISMISS_ALL } from '~/modules/post/queries'

import { usePost } from '~/modules/post/hooks'
import { useTrackAllPostCommentsDismissed } from '~/shared/hooks/tracking'

/**
 *
 */
export default function useDismissAll() {
  const client = useApolloClient()

  const { getPost, setPost, queryPost } = usePost()
  const trackAllPostCommentsDismissed = useTrackAllPostCommentsDismissed()

  /**
   *
   */
  // @ts-expect-error TS(7006) FIXME: Parameter 'postId' implicitly has an 'any' type.
  const dismissAll = (postId) => {
    client.mutate({
      mutation: MUTATION_DISMISS_ALL,
      variables: { type: 'post', targetId: postId },
      // @ts-expect-error TS(2322) FIXME: Type '(cache: any, { data }: { data: any; }) => vo... Remove this comment to see the full error message
      update: getUpdateCallback(postId),
      optimisticResponse: {
        __typename: 'Mutation',
        engageDismissAll: {
          __typename: 'EngagementMutationResponse',
          success: true,
          code: 'OPTIMISTIC_RESPONSE',
        },
      },
    })
  }

  /**
   *
   */
  // @ts-expect-error TS(7031) FIXME: Binding element 'postId' implicitly has an 'any' t... Remove this comment to see the full error message
  const dismissAllDone = ({ postId }) => {
    const post = getPost(postId)

    if (post.dismissingAll) {
      queryPost({
        fetchPolicy: 'network-only',
        variables: { id: postId, refreshMedia: false },
      })

      trackAllPostCommentsDismissed(post)
    }
  }

  /**
   *
   */
  // @ts-expect-error TS(7006) FIXME: Parameter 'postId' implicitly has an 'any' type.
  const getUpdateCallback = (postId) => {
    // @ts-expect-error TS(7006) FIXME: Parameter 'cache' implicitly has an 'any' type.
    return (cache, { data }) => {
      const { success, code } = data.engageDismissAll

      if (!success) {
        console.error('Dismiss all failed.')
        return
      }

      const post = getPost(postId)

      const updatedPost = update(post, {
        dismissingAll: { $set: true },
      })

      setPost(post.id, updatedPost)
    }
  }

  return {
    dismissAll,
    dismissAllDone,
  }
}
